import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mobile-tooltip-wrapper" }
const _hoisted_2 = ["position"]
const _hoisted_3 = { class: "repayment-option-sections" }
const _hoisted_4 = { class: "repayment-option-section" }
const _hoisted_5 = { class: "repayment-option-header" }
const _hoisted_6 = { class: "repayment-option-section repayment-option-payment-amounts-wrapper" }
const _hoisted_7 = { class: "payment-wrapper" }
const _hoisted_8 = { class: "payment in-school" }
const _hoisted_9 = { class: "payment-wrapper" }
const _hoisted_10 = { class: "payment post-school" }
const _hoisted_11 = {
  key: 0,
  class: "repayment-option-radio"
}

import { ref, computed, onMounted, PropType } from "vue";
import { useStore } from "vuex";
import { FormSchema } from "@/models/form";
import { RatePlanVM, RatePlanRepaymentVM } from "@/models/loanConfiguration";
import BaseFormFieldRadio from "@/components/v2/shared/BaseFormFieldRefiRadio.vue";
import RepaymentTypeTooltip from "@/components/pel-loan-configuration/RepaymentTypeTooltip.vue";

interface Form {
  repaymentOption?: RatePlanRepaymentVM;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PelLoanRepaymentOption',
  props: {
  ratePlan: {
    type: Object as PropType<RatePlanVM>,
    required: true,
  },
  repayment: {
    type: Object as PropType<RatePlanRepaymentVM>,
    required: true,
  },
  isMobile: {
    type: Boolean,
    required: true,
  },
  active: {
    type: Boolean,
    required: true,
  },
  position: {
    type: String,
    default: "",
  },
},
  emits: ["updateRepaymentOption"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const props = __props;

const schema = ref<FormSchema>({
  paymentOption: {
    name: "paymentOption",
    type: "radio",
    required: true,
    hideLabel: true,
  },
});

const emit = __emit;

let form = ref<Form>({
  repaymentOption: undefined,
});

const repaymentOptionRef = ref<undefined | HTMLElement>();

const mobile = computed(() => props.isMobile);

const savingChanges = computed<boolean>(() => store.state.loanConfigurationModule.savingChanges);

const inSchoolPaymentLabel = computed(() =>
  mobile.value ? "Monthly" : `${props.repayment?.monthlyInSchoolPaymentLabel} Monthly Payments`,
);

const postGradPaymentLabel = computed(() =>
  mobile.value ? "Monthly" : `${props.repayment?.monthlyPostSchoolPaymentLabel} Monthly Payments`,
);

const selectedRatePlan = computed(() => store.state.loanConfigurationModule.selectedRatePlan);

const selectedRepaymentOption = computed(
  () => store.state.loanConfigurationModule.selectedRepaymentOption,
);

const isSelected = computed<boolean>(
  () =>
    selectedRatePlan.value &&
    selectedRepaymentOption.value &&
    selectedRatePlan.value.id === props.ratePlan?.id &&
    selectedRepaymentOption.value.repaymentTypeId === props.repayment.repaymentTypeId,
);

async function updateRepaymentOption(repayment: any) {
  if (repayment) {
    await store.dispatch("loanConfigurationModule/setSelectedRatePlan", props.ratePlan);
    await store.dispatch("loanConfigurationModule/setSelectedRepaymentOption", repayment);
  }
}

function setRepaymentOption() {
  if (isSelected.value) {
    form.value.repaymentOption = selectedRepaymentOption.value;
  }
}

onMounted(() => {
  setRepaymentOption();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.repayment.repaymentTypeTooltipText)
        ? (_openBlock(), _createBlock(RepaymentTypeTooltip, {
            key: 0,
            repayment: __props.repayment
          }, null, 8, ["repayment"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "repayment-option-wrapper",
      position: __props.position
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(__props.repayment.repaymentTypeDetails?.name || __props.repayment?.repaymentTypeName) + " ", 1),
            (__props.repayment.repaymentTypeTooltipText)
              ? (_openBlock(), _createBlock(RepaymentTypeTooltip, {
                  key: 0,
                  class: "desktop-tooltip-wrapper",
                  repayment: __props.repayment
                }, null, 8, ["repayment"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(__props.repayment.monthlyInSchoolPaymentDisplay), 1),
              _createElementVNode("p", null, _toDisplayString(inSchoolPaymentLabel.value), 1)
            ])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "divider" }, null, -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", null, _toDisplayString(__props.repayment.monthlyPostSchoolPaymentDisplay), 1),
              _createElementVNode("p", null, _toDisplayString(postGradPaymentLabel.value), 1)
            ])
          ])
        ])
      ]),
      (__props.position === 'center')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(BaseFormFieldRadio, {
              ref_key: "repaymentOptionRef",
              ref: repaymentOptionRef,
              modelValue: _unref(form).repaymentOption,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).repaymentOption) = $event)),
                updateRepaymentOption
              ],
              schema: schema.value.paymentOption,
              options: [{ label: '', value: __props.repayment }],
              checked: isSelected.value,
              disabled: savingChanges.value
            }, null, 8, ["modelValue", "schema", "options", "checked", "disabled"])
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2)
  ], 64))
}
}

})